import React from 'react'
import styled from 'styled-components'
import { Box, Circle, Flex, TextBox, COLORS, Color } from '@revolut/ui-kit'

import { ApmProvider } from '../../types/common'
import { APM_ICONS, APM_NAMES } from '../../constants/common'

type Props = {
  apmProvider: ApmProvider
}

const BoxWithImage = styled(Box)<{ image: string }>`
  background-image: url('${({ image }) => image}');
  background-repeat: no-repeat;
  background-position: center;
`

const CircleOutlined = styled(Circle)`
  border: 1px solid ${COLORS[Color.GREY_TONE_20]};
`

export const ApmAvatar = ({ apmProvider }: Props) => {
  return (
    <Flex my={1}>
      <CircleOutlined p='.25rem' size={24}>
        <BoxWithImage width={16} height={16} image={APM_ICONS[apmProvider]} />
      </CircleOutlined>
      <TextBox ml={1}>{APM_NAMES[apmProvider]}</TextBox>
    </Flex>
  )
}
